var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.458 16.263a2.333 2.333 0 102.915 3.641 2.333 2.333 0 00-2.915-3.64zm1.832 2.34l-.73.437a.44.44 0 01-.6-.146.437.437 0 01.152-.6l.519-.31v-.63a.432.432 0 01.431-.437.44.44 0 01.438.437v.875a.438.438 0 01-.21.373z",
    fill: "#FEAAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.663 11.521h-.875V9.305c0-.158-.14-.234-.234-.234a.234.234 0 00-.087.018L9.84 10.833a.784.784 0 00-.508.74v.392a2.18 2.18 0 00-.875 1.75v-2.141c0-.694.426-1.313 1.074-1.558l4.631-1.75a1.111 1.111 0 011.5 1.038v2.217z",
    fill: "#655AEC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.542 16.042a.291.291 0 01-.286.291h-.851c-.31 0-.59-.227-.613-.53a.582.582 0 01.578-.636h.88c.17.005.292.134.292.291v.584z",
    fill: "#FEAAFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.958 14.554c.321 0 .584-.262.584-.583v-.257a2.198 2.198 0 00-2.194-2.193h-6.696c-.496 0-.951.163-1.319.443a2.18 2.18 0 00-.875 1.75v1.038c0 .222.234.362.444.292.326-.11.67-.169 1.015-.169a3.214 3.214 0 013.208 3.208c0 .42-.11.881-.286 1.29-.093.21.053.46.28.46h4.23a2.198 2.198 0 002.193-2.193v-.11a.585.585 0 00-.584-.584h-.507c-.56 0-1.097-.344-1.243-.887a1.174 1.174 0 01.315-1.155c.216-.221.514-.35.84-.35h.595zm-6.708-.117a.44.44 0 01-.438-.437.44.44 0 01.438-.438h2.917a.44.44 0 01.437.438.44.44 0 01-.437.438H12.25z",
    fill: "#655AEC"
  }))));
}

export default SvgBill;